'use client'
import { capitalizeFirstLetter } from '@/core/lib/utils/capitalize-first-letter'
import { PostModel } from '@/features/blog/types/models/post.model'
import { Link } from '@/i18n/navigation'
import Image from 'next/image'
import React from 'react'
import { Calendar, Clock } from 'lucide-react'

export const Post: React.FC<PostModel & { className?: string }> = ({
  brief,
  cover,
  name,
  slug,
  createdAt,
  timeToRead,
  className = '',
}) => {
  return (
    <>
      <Link
        href={`/blog/post/${slug}`}
        prefetch={false}
        className={`group flex h-full flex-col overflow-hidden rounded-md border-1 border-gray-100 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-sm ${className}`}
      >
        <div className='relative h-52 w-full overflow-hidden'>
          <Image
            height={208}
            width={208}
            alt={name}
            src={cover?.url || '/placeholder.png'}
            className='h-full w-full object-cover transition-transform duration-300 group-hover:scale-105'
          />
          <div className='absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100' />
        </div>

        <div className='flex flex-1 flex-col justify-between gap-3 p-4'>
          <div>
            <h6 className='group-hover:text-creamed-cron text-lg font-semibold text-gray-900 transition-colors duration-200'>
              {capitalizeFirstLetter(name)}
            </h6>
            <p className='mt-1 line-clamp-3 text-sm leading-relaxed text-gray-600'>
              {capitalizeFirstLetter(brief)}
            </p>
          </div>

          <div className='mt-2 flex items-center justify-between text-xs text-gray-500'>
            <div className='flex items-center gap-1'>
              <Calendar className='h-3.5 w-3.5' />
              <span>{new Date(createdAt).toLocaleDateString()}</span>
            </div>
            <div className='flex items-center gap-1'>
              <Clock className='h-3.5 w-3.5' />
              <span>{timeToRead} min read</span>
            </div>
          </div>
        </div>
      </Link>
    </>
  )
}
